import React from 'react'
import { NavigationOptions, PaginationOptions } from 'swiper/types'

import { HouseDetail } from '@f-fertighaus/applications/Next/types/houseDetailsResponse'
import { SimilarHouse } from '@f-fertighaus/applications/Next/types/similarHousesResponse'

interface UseSwiperOptionsReturn {
  paginationOptions: PaginationOptions
  navigationOptions: NavigationOptions
  refs: Record<string, React.RefObject<HTMLDivElement>>
}

export function useSwiperOptions<Item extends SimilarHouse | HouseDetail>(
  data: Item[]
): UseSwiperOptionsReturn {
  const navigationPrevRef = React.useRef(null)
  const navigationNextRef = React.useRef(null)

  const paginationOptions = React.useMemo<PaginationOptions>(
    () =>
      data.length > 3
        ? {
            clickable: false,
            type: 'bullets',
            dynamicBullets: true,
            dynamicMainBullets: 3
          }
        : {
            clickable: false,
            type: 'bullets'
          },
    [data.length]
  )

  const navigationOptions = React.useMemo<NavigationOptions>(
    () => ({
      enabled: true,
      prevEl: navigationPrevRef.current,
      nextEl: navigationNextRef.current
    }),
    []
  )

  return {
    paginationOptions,
    navigationOptions,
    refs: {
      navigationPrevRef,
      navigationNextRef
    }
  }
}
